var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClockGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2318 8.00016C15.2318 11.4062 12.27 14.1668 8.61589 14.1668C4.96177 14.1668 2 11.4062 2 8.00016C2 4.59416 4.96177 1.8335 8.61589 1.8335C12.27 1.8335 15.2318 4.59416 15.2318 8.00016Z",
    stroke: "#CECED4",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0709 9.96162L8.37451 8.46229V5.23096",
    stroke: "#CECED4",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClockGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clockGrey.0ad996609fef1824693bc9f623b4f3eb.svg";